module.exports = __webpack_public_path__ + "img/421.5d08351d.png";